/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBarBoth = createReactComponent("arrow-bar-both", "IconArrowBarBoth", [
  ["path", { d: "M8 12h-6", key: "svg-0" }],
  ["path", { d: "M5 15l-3 -3l3 -3", key: "svg-1" }],
  ["path", { d: "M22 12h-6", key: "svg-2" }],
  ["path", { d: "M19 15l3 -3l-3 -3", key: "svg-3" }],
  ["path", { d: "M12 4v16", key: "svg-4" }]
]);

export { IconArrowBarBoth as default };
//# sourceMappingURL=IconArrowBarBoth.js.map
